import React from 'react';
import ReactDOM from 'react-dom';
import AppTheme from './AppTheme';

ReactDOM.render(
  <AppTheme />,
  document.getElementById('root')
);
